<template>
  <div class="activities">
    <div class="title">
      <div></div>
      活动列表
    </div>
    <div class="query">
    
      <div class="query-box">
        <el-input v-model="query" placeholder="活动名称"></el-input>
      </div>

      <el-button type="primary" @click="inquire">查询</el-button>
      <el-button type="primary" @click="addShow=true">新增</el-button>
    </div>
    <div class="activities-main">
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column align="center" type="index" label="序号" width="50">
        </el-table-column>
            <el-table-column align="center" prop="activityName" label="活动名称">
        </el-table-column>
    
        <el-table-column align="center" prop="startTime" label="活动开始时间">
        </el-table-column>
         <el-table-column align="center" prop="endTime" label="活动结束时间">
        </el-table-column>

        <el-table-column align="center" prop="activityCount" label="活动码可使用次数">
        </el-table-column>
             <el-table-column align="center" prop="addVipDay" label="增加会员有效时间天数">
        </el-table-column>

        <el-table-column align="center" prop="activityCode" label="兑换码">
        </el-table-column>

       

        <el-table-column align="center" label="操作" width="240">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="primary"
              @click="activityList(scope.row.id)"
              >兑换列表</el-button
            >
            <!-- <el-button size="mini" type="danger" @click="del(scope.row.id)"
              >删除</el-button
            > -->
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div class="paging">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[1, 3, 5, 10]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
    <!-- 新增 -->

    <el-dialog
      title="提示"
      :visible.sync="addShow"
      width="50%"
      @closed="handleClose"
    >
      <div class="main">
        <el-form ref="forms" :model="form" label-width="170px" :rules="rules">
          <el-form-item label="活动名称" prop="activityName">
            <el-input
              v-model="form.activityName"
              placeholder="活动名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="活动码可使用次数" prop="activityCount">
            <el-input
               type="number"
              v-model="form.activityCount"
              placeholder="活动码可使用次数"
               :min='0'
            ></el-input>
          </el-form-item>
          <el-form-item  label="增加会员有效时间天数" prop="addVipDay">
            <el-input
             type="number"
              v-model="form.addVipDay"
              placeholder="增加会员有效时间天数"
              :min='0'
            ></el-input>
          </el-form-item>
          <el-form-item label="活动时间" prop="activityTime">
            <el-date-picker
              format="yyyy-MM-dd HH:mm"
              v-model="form.activityTime"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addShow = false">取 消</el-button>
        <el-button type="primary" @click="addSubmit('forms')">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import moment from "moment";
import local from "@/utils/local.js";
import { delActivity, PlatformActivityList,PlatformActivityAdd } from "@/api/api";
import reg from "@/utils/reg.js";
export default {
  data() {
    return {
      ruleList: [],
      query: "",
      startTime: "",
      endTime: "",
      activityTime: "",
      total: 0,
      currentPage: 1,
      pageSize: 10,
      tableData: [],
      adminId: "",
      types: "",
      type: "",
      addShow: false,
      form: {
        activityTime: "",
        activityName: "", //活动名称
        startTime: "",
        endTime: "",
        activityCount: "",
        addVipDay: "",
      },
      rules: {
        //验证规则
        activityName: [
          { required: true, message: "请输入活动名称", trigger: "blur" },
        ],
        activityTime: [
          { required: true, message: "请选择活动时间", trigger: "blur" },
        ],
        activityCount: [
          {
            required: true,
            message: "请输入活动码可使用次数",
            trigger: "blur",
          },
        ],
        addVipDay: [
          {
            required: true,
            message: "请输入增加会员有效时间天数",
            trigger: "blur",
          },
        ],
      },
    };
  },
  created() {
    this.getList();
  },
  methods: {
    // 新增
    addSubmit: reg._debounce(function (formName) {
      (this.form.startTime = moment(this.form.activityTime[0]).format(
        "YYYY-MM-DD HH:mm:ss"
      )),
        (this.form.endTime = moment(this.form.activityTime[1]).format(
          "YYYY-MM-DD HH:mm:ss"
        ));
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          let { code, msg } = await PlatformActivityAdd({
            activityName: this.form.activityName,
            activityCount: this.form.activityCount,
            startTime: this.form.startTime,
            endTime: this.form.endTime,
            addVipDay: this.form.addVipDay,
          });

          if (code == 200) {
            this.$message({
              type: "success",
              message: "添加成功",
            });
            this.addShow = false;
            this.getList();
          }
        }
      });
    }, 200),
    // 关闭弹窗
    handleClose() {
         this.addShow = false;
      this.form = {
        activityTime: "",
        activityName: "", //活动名称
        startTime: "",
        endTime: "",
        activityCount: "",
        addVipDay: "",
      };
    },
    // 删除活动
    del(id) {
      this.$confirm("将删除此活动, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          let res = await delActivity({
            id: id,
          });
          if (res.code == 200) {
            this.$message({
              type: "success",
              message: "删除成功!",
            });
            this.getList();
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    // 活动列表
    activityList(id) {
      this.$router.push("platformActivityList?activityId=" + id);
    },

    //  获取活动列表
    async getList() {
      let res = await PlatformActivityList({
        activityName: this.query,
        pageSize: this.pageSize,
        pageNum: this.currentPage,

      });
      console.log(res);
      let { data } = res;
      //  边界判断
      if (!data.list.length && this.currentPage !== 1) {
        this.currentPage -= 1;
        this.getList();
      }
      this.tableData = data.list;
      this.total = data.total;
    },

    // 查询
    inquire() {

      this.getList();
    },
    // 刷新
    refresh() {
      this.query = "";
      this.startTime = "";
      this.endTime = "";
      this.activityTime = "";
      this.getList();
    },

    //每页多少条
    handleSizeChange(val) {
      this.pageSize = val;
      this.getList();
    },
    //当前多少页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getList();
    },
  },
};
</script>

<style lang="less" scoped>
.activities {
  // height: 100%;
  background: #fff;
  padding: 15px;
  color: #303133;
  .title {
    display: flex;
    align-items: center;
    font-size: 16px;
    font-weight: 700;
    div {
      width: 3px;
      height: 16px;
      background: #409eff;
      margin-right: 10px;
    }
  }
  .query {
    margin: 15px 0 30px;
    display: flex;
    align-items: center;
    .query-box {
      display: flex;
      align-items: center;
      margin-right: 20px;
      .el-input {
        width: 260px;
      }
      span {
        width: 60px;
      }
    }
  }
  .activities-main {
    margin: 15px 0;
  }
  .paging {
    display: flex;
    justify-content: flex-end;
  }
}
.active {
  color: #33b959;
}
</style>